<template>
	<div class="main">
		<header class="page-title">
			<h2>Editing {{ provider.name }} provider</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('dashboard_access.update')" href="#" class="btn btn-md btn-success" @click="saveProvider">
					<i class="fas fa-save"></i> Save Changes
				</a>
			</div>
		</header>

		<div class="flex box">
			<div class="eight-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">General Information</h3>
					</header>
					<div class="card-body">
						<div class="flex box">
							<div class="nine">
								<div class="flex box">
									<div class="form-group six">
										<label for="name">Provider Name</label>
										<input id="name" name="name" type="text" required v-model="provider.name">
										<p class="input-error" v-if="errors.errors.name">{{ errors.errors.name }}</p>
									</div>
									<div class="form-group six">
										<label for="slug">Provider Slug</label>
										<input id="slug" name="slug" type="text" required v-model="provider.slug">
										<p class="input-error" v-if="errors.errors.slug">{{ errors.errors.slug }}</p>
									</div>
								</div>
								<div class="form-group">
									<label for="affiliate-type">Affiliate type</label>
									<select id="affiliate-type" name="affiliate-type" v-model="provider.stats_affiliate_type_id">
										<option v-for="type in affiliateTypes" :key="provider.stats_affiliate_type_id" :value="type.id">
											{{ type.name }}
										</option>
									</select>
									<p class="input-error" v-if="errors.errors.stats_affiliate_type_id">{{
											errors.errors.stats_affiliate_type_id
										}}</p>
								</div>
								<div class="form-group">
									<label for="state">Provider</label>
									<label class="state">
										<input id="state" name="state" type="checkbox" v-model="provider.state"> State
									</label>
									<p class="input-error" v-if="errors.errors.state">{{ errors.errors.state }}</p>
								</div>
								<div class="form-group">
									<label for="account_email">Email Address</label>
									<input id="account_email" name="account_email" type="email" value="" required v-model="provider.account_email">
								</div>
								<div class="form-group">
									<label for="custom_field">Custom field</label>
									<input id="custom_field" name="custom_field" type="text" value="" required v-model="provider.custom_field">
								</div>
								<div class="form-group">
									<label for="last_imported">Last imported</label>
									<input id="last_imported" name="last_imported" type="text" value="" required v-model="provider.last_imported">
								</div>
							</div>
							<div class="three text-center">
								<table>
									<thead>
									<tr>
										<th>Cron Logs</th>
									</tr>
									</thead>
									<tbody v-if="cronLogs.length > 0">
									<tr v-for="log in cronLogs">
										<td>{{ log.last_imported }}</td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<aside class="four-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">Affiliate Access</h3>
					</header>
					<div class="card-body">
						<form>
							<div class="form-group">
								<label for="account_password">Password</label>
								<input id="account_password" name="account_password" type="text" v-model="password">
							</div>
							<div class="form-group">
								<label for="account_api_key">Api key</label>
								<input id="account_api_key" name="account_api_key" type="text" v-model="api">
							</div>
							<div class="form-group">
								<label for="request_url">Request URL:</label>
								<input id="request_url" name="request_url" type="text" v-model="provider.request_url">
							</div>
							<div class="text-center mt-2">
								<a href="#" class="btn btn-md btn-primary" @click="saveAccessData"><i class="fas fa-check"></i> Save Access Data</a>
							</div>
						</form>
					</div>
				</div>
				<div class="card" v-if="provider.state">
					<header class="card-header">
						<h3 class="card-title">Test Affiliate Connection</h3>
					</header>
					<div class="card-body">
						<form>
							<div class="form-group">
								<label>You can test here the connection to the provider does it work.</label>
								<div v-if="!testing" class="text-center mt-2">
									<a v-if="testResponse === ''" href="#" class="btn btn-md btn-warning" @click.prevent="testConnection"><i class="fas fa-check"></i> Test connection</a>
									<span v-if="testResponse === true" class="badge badge-success">Connection was Success!!</span>
									<span v-if="testResponse === false" class="badge badge-danger">Error: check are the credentials correct!</span>
								</div>
								<div v-if="testing" class="flex center text-center mb-1">
									<i class="fas fa-cog fa-spin fa-2x"></i>
									Loading....
								</div>
							</div>
						</form>
					</div>
				</div>
			</aside>
		</div>
	</div>
</template>

<script>
import Errors from '../../Utils/Errors.js';
import {eventBus} from "../../app";

export default {
	name: "StatsProvider",
	props: {
		dataProvider: {
			type: Object
		},
		dataAffiliateTypes: {
			type: Array
		},
		dataCronLogs: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			provider: this.dataProvider,
			affiliateTypes: this.dataAffiliateTypes,
			cronLogs: this.dataCronLogs,
			userRoles: this.$currentUserRoles,
			password: this.dataProvider.account_password ? atob(this.dataProvider.account_password) : '',
			api: this.dataProvider.account_api_key ? atob(this.dataProvider.account_api_key) : '',
			testing: false,
			testResponse: '',
			errors: new Errors()
		}
	},
	methods: {
		saveProvider: function () {
			axios.put('/api/' + this.$selectedSite.slug + '/statsProvider/' + this.provider.id, this.provider)
					.then(response => {
						this.$toastr.success('Provider saved successfully', 'Success');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Provider save failed.', e.response.data.message);
					});
		},
		saveAccessData: function () {
			axios.post('/api/' + this.$selectedSite.slug + '/statsProvider/' + this.provider.id + '/updateAccessData', {
				account_password: this.password ? btoa(this.password) : null,
				account_api_key: this.api ? btoa(this.api) : null,
				request_url: this.provider.request_url
			})
					.then(response => {
						this.$toastr.success('Provider access data saved successfully', 'Success');
					})
					.catch(e => {
						this.$toastr.error('Provider access data save failed.', e.response.data.message);
					});
		},
		testConnection: function () {
			this.testing = true;
			axios.get('/api/' + this.$selectedSite.slug + '/statsProvider/' + this.provider.id + '/testConnection')
				.then(response => {
					this.testing = false;
					if (response.data.success) {
						this.testResponse = true;
					} else {
						this.testResponse = false;
						if (response.data.message.length) {
							this.$toastr.error('Provider connection test failed. ', response.data.message);
						} // if
					} // if

				}
			);
		},
	}
}
</script>

<style scoped>

</style>
